import { useMemo } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Select } from "antd";
import { AppStrings } from "../../../../../utils/constants/AppStrings";
import ActionsByCategory from "../../../Roles/Permissions/ActionsByCategory/ActionsByCategory";
import {
  READ_ONLY_ACCESS_KEY,
  readOnlyAccessRow,
} from "../../../Roles/Permissions/readOnlyAccessRow";
import "../../../Roles/Actions/stylesNewRole.css";
import "../stylesStaffDetails.css";
import SidebarPreview from "../../../Roles/SidebarPreview/SidebarPreview";
import { useGetPermissionsSchema, useGetRoles } from "../../../../../queries/useRolesApi";
import "./stylesPermissionsTab.css";
import { apiRoleToUiRole } from "../../../../../utils/roleUtils";


function PermissionsTab({ staff: _staff, role = "superadmin", onRoleChange, showSaveButton, onSaveRoleChange, isSaveRoleLoading = false, localStatus = "", canEditPAMUser = false }) {
  // Mock permissions data based on role - in real implementation, this would come from API
  // This function would fetch permissions based on the selected role
  const { data: apiRoles, isLoading: isRolesLoading } = useGetRoles();
  const { data: schema } = useGetPermissionsSchema();
  const roles = useMemo(
    () => apiRoles?.map((apiRole) => apiRoleToUiRole(apiRole, schema)) ?? [],
    [apiRoles, schema],
  );

  const getPermissionsByRole = (roleValue) => {
    const rolesWithNew = roles;
    const baseSelected = rolesWithNew.find((r) => r.value === roleValue);
    return baseSelected?.permissions ?? {};

  };

  const permissions = getPermissionsByRole(role);

  const actionsList = useMemo(
    () => [readOnlyAccessRow(), ...(schema?.available_actions ?? [])],
    [schema?.available_actions],
  );

  // The actions this role grants, keyed for O(1) lookup, plus its lock.
  const roleActions = useMemo(() => {
    const apiRole = apiRoles?.find((r) => r.id === role);
    return (apiRole?.actions ?? []).reduce(
      (acc, actionKey) => ({ ...acc, [actionKey]: true }),
      { [READ_ONLY_ACCESS_KEY]: Boolean(apiRole?.read_only_access) },
    );
  }, [apiRoles, role]);

  return (
    <div className="permissions-tab-container">
      {isRolesLoading && <div className="permissions-tab-loading">Loading...</div>}
      {!isRolesLoading && (
        <>
          <div className="staff-details-role-section">
            <div className="staff-details-role-header-container">
              <div className="staff-details-role-header-left">
                <span className="staff-details-role-label">{AppStrings.ROLE}</span>
                <InfoCircleOutlined className="staff-details-role-info-icon" />
              </div>
              <div className="staff-details-role-header-right">
                {showSaveButton && (
                  <button
                    className="staff-details-save-role-button"
                    onClick={onSaveRoleChange}
                    disabled={isSaveRoleLoading}
                  >
                    {isSaveRoleLoading ? "Saving…" : "Save Changes"}
                  </button>
                )}
              </div>
            </div>
            <Select
              disabled={localStatus === "Deleted" || !canEditPAMUser}
              loading={isRolesLoading}
              value={role}
              onChange={onRoleChange}
              virtual={false}
              className={`staff-details-role-select ${localStatus === "Deleted" || !canEditPAMUser ? "staff-details-role-select--disabled" : ""}`}
              placeholder="Choose the role"
              options={roles.map((roleOption) => ({
                value: roleOption.value,
                label: (
                  <div className="staff-details-role-option">
                    <span
                      className="staff-details-role-option-dot"
                      style={{ backgroundColor: roleOption.color }}
                    />
                    <span>{roleOption.label}</span>
                  </div>
                ),
              }))}
            />
          </div>

          <div className={`permissions-tab-overview-container ${localStatus === "Deleted" || !canEditPAMUser ? "permissions-tab-overview-container--disabled" : ""}`}>
          
            <div className="permissions-tab-overview-left">
            <div className="permissions-tab-actions-header">
              <div className="permissions-tab-actions-title">
                <span>{AppStrings.PERMISSIONS}</span>
                <InfoCircleOutlined className="info-icon" />
              </div>
            </div>
              <SidebarPreview
                permissions={permissions}
                availablePermissions={schema?.available_permissions}
              />
            </div>

          <div className="permissions-tab-actions-section">
            <div className="permissions-tab-actions-header">
              <div className="permissions-tab-actions-title">
                <span>{AppStrings.ACTIONS}</span>
                <InfoCircleOutlined className="info-icon" />
              </div>
            </div>
            <ActionsByCategory
              actions={actionsList}
              values={roleActions}
              disabled={true}
            />
          </div>
          </div>
        </>
      )}
    </div>
  );
}

export default PermissionsTab;

